module.exports = __webpack_public_path__ + "img/login-bg.e2134055.jpg";